import { SingleEthereum as Client } from "./client";

export * from "./constants";
export * from "./types";

export const SingleEthereum = Client;
export default Client;
